import { render, staticRenderFns } from "./ComponenteForm.vue?vue&type=template&id=b0c251ba&scoped=true&"
import script from "./ComponenteForm.vue?vue&type=script&lang=ts&"
export * from "./ComponenteForm.vue?vue&type=script&lang=ts&"
import style0 from "./ComponenteForm.vue?vue&type=style&index=0&id=b0c251ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c251ba",
  null
  
)

export default component.exports